<template>
  <v-container
    id="store"
    fluid
    tag="section"
  >
    <filter-form :filter-form="filterForm"/>
    <store-table :storeList="storeList"/>
    <v-row class="mt-4">
      <v-col
        cols="12"
        sm="6"
      />
      <v-col
        cols="12"
        sm="6"
      >
        <v-pagination
          v-if="totalItem > limit"
          v-model="currentPage"
          class="justify-sm-end"
          :length="getTotalItem(totalItem, limit)"
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import FilterForm from './components/FilterForm.vue'
  import StoreTable from './components/StoreTable'
  import RepositoryFactory from '../../repositories/RepositoryFactory'
  const StoreRepository = RepositoryFactory.get('store')
  export default {
    components: { StoreTable, FilterForm },
    data () {
      return {
        filterForm: {
          keyword: '',
        },
        storeList: [],
        currentPage: 1,
        limit: 10,
        totalItem: 0,
        loading: true,
      }
    },
    watch: {
      currentPage: {
        handler () {
          this.getStoreList()
        },
      },
      limit: {
        handler () {
          if (this.currentPage === 1) {
            this.getStoreList()
          } else {
            this.currentPage = 1
          }
        },
      },
    },
    async created () {
      this.getStoreList();
      Bus.$on('store-list-filter', (filterForm) => {
        this.filterForm = filterForm
        this.currentPage = 1
        this.getStoreList()
      })
      Bus.$on('store-reload', () => {
        this.getStoreList()
      })
    },
    beforeDestroy () {
      Bus.$off('store-list-filter')
    },
    methods: {
      async getStoreList () {
        this.loading = true
        const params = {
          limit: this.limit,
          page: this.currentPage - 1,
          keyword: this.filterForm.keyword,
          status: this.filterForm.status
        }
        const loader = this.$loading.show()
        const response = await StoreRepository.list(params)
        loader.hide()
        this.loading = false
        if (response.success) {
          this.storeList = _.get(response, 'data', [])
          this.totalItem = response.totalItem
        }
      },
    },
  }
</script>
